import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import golf from "../../../../assets/info/golf-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/vw-golf/golf-mk-5-suspension.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";

const VWGolf = () => {
  useSmallNav("Volkswagen Golf");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Volkswagen Golf"} bolder />
        <InfoHero image={golf} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Pedders is pleased to announce that they have now brought the SportsRyder Ezifit Suspension concept to the VW Golf mk5 and 6."
              }
            />
            <InfoHeader
              size="smaller"
              text={
                "Do you want to lower your car, improve the looks and handling? But still want to retain a decent level of comfort. Concerned that coilovers will be too hard?"
              }
            />
            <p>
              Then the Pedders SportsRyder Ezifit kit is the right choice for
              you.
            </p>
            <p>
              This kit includes upgraded shocks, featuring revised damping rates
              for improved control to match Pedders SportsRyder coil springs. To
              make it as Ezi as possible, this kit comes with fully assembled
              front struts making fitting as "Ezi" as it can be! Lowered look &
              great handling with a decent ride at a great price - all in a
              pre-assembled kit - too Ezi!
            </p>
            <InfoHeader size="smaller" text={"Key Features:"} />
            <p>
              Pedders SportsRyder EziFit Suspension kit is the ideal alternative
              to buying separate components or coilovers when wanting to lower
              your Golf.
            </p>
            <p>
              Reduced installation time and a decent ride/handling balance are
              the key benefits from the use of the Pedders EziFit Kit as the
              springs, struts and mounts are all supplied pre-assembled and
              ready to install. No need to use a spring compressor as the work
              is already done for you! Just unbolt the old and bolt in the new
              ITS PLUG & PLAY suspension at its best!
            </p>
            <ul>
              <li>
                Supplied as a MATCHED SET of pre-assembled suspension components
                including Pedders SportsRyder gas struts, Pedders SportsRyder
                lowered coil springs, bump stops, boot kits, and front strut
                mounts.
              </li>
              <li>
                Reduced installation time as the components are supplied
                pre-assembled and ready for direct fitment.
              </li>
              <li>
                Individually shock dyno-tested as a complete suspension system
                mated to your existing O.E. hardware for quality assurance &amp;
                performance.
              </li>
              <li>
                The Pedders EziFit will lower your&nbsp;Golf&nbsp;by up to 35mm
                depending on the model. The 2&nbsp;Golf's shown in the pictures
                are fitted with the Pedders SportsRyder Ezifit Kit.
              </li>
              <li>
                Pedders SportsRyder gas struts in the EziFit kit are made from
                heavy duty twin-tube gas construction technology &amp; heavy
                duty reinforced double welded mountings for long term
                durability.
              </li>
              <li>
                The complete kit is a system designed and valved to work
                together. You will experience dynamic sports ride &amp; handling
                that is suitable for daily driving as well as performance
                driving without a harsh ride.
              </li>
              <li>All backed by our 2 Year / 40,000 km warranty.</li>
            </ul>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Volkswagen")
              .models.find((e) => e.display === "Golf")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Golf MK5 SportsRyder Ezifit Suspension Kits"}
              />
              <div>
                <StyledImgParts
                  src={part1}
                  alt="Golf MK5 SportsRyder Ezifit Suspension Kits"
                />
              </div>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/_GNsgVAQwiA"
              title={"VW Golf Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/wzDv0cCzXXQ"
              title={"VW Golf Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"VW Golf Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Volkswagen" model="Golf" />
      </Container>
    </section>
  );
};

export default VWGolf;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
